<div class="base-infopage-wrapper">
    <infopage-header title="Info"></infopage-header>
    <ng-content class="infopage-content"></ng-content>
    <page-footer [staticMapInput]="staticMapInput()" [hideSmallMap]="hideSmallMap()" (navigateToMap)="navigateToMap.emit()"></page-footer>
</div>
@if (staticMapInput()) {
    <staticmap
        class="big-map"
        [latlng]="staticMapInput().latlng"
        [iconEstateType]="staticMapInput().iconEstateType"
        [zoom]="19"
        [drag]="true"
        [zooming]="true"
        [showLink]="false"
    >
    </staticmap>
}
